import React from 'react';
import { Users, FolderOpen, FolderLock, FileText, FileCheck } from 'lucide-react';
import styles from './AdminDashboardSection.module.scss';
import LoadingSpinner from '../Shared/LoadingSpinner.tsx';

interface AdminDashboardStats {
  totalUsers: number;
  totalPublicProjects: number;
  totalPrivateProjects: number;
  totalPublicQuotations: number;
  totalPrivateQuotations: number;
}

interface AdminDashboardSectionProps {
  stats: AdminDashboardStats;
  loading: boolean;
}

const AdminDashboardSection: React.FC<AdminDashboardSectionProps> = ({ stats, loading }) => {
  if (loading) {
    return <LoadingSpinner message="Cargando información general..." />;
  }

  const statCards = [
    {
      Icon: Users,
      label: 'Total de Usuarios',
      value: stats.totalUsers,
      color: '#234ba2'
    },
    {
      Icon: FolderOpen,
      label: 'Proyectos Públicos',
      value: stats.totalPublicProjects,
      color: '#2196f3'
    },
    {
      Icon: FolderLock,
      label: 'Proyectos Privados',
      value: stats.totalPrivateProjects,
      color: '#673ab7'
    },
    {
      Icon: FileText,
      label: 'Cotizaciones Públicas',
      value: stats.totalPublicQuotations,
      color: '#009688'
    },
    {
      Icon: FileCheck,
      label: 'Cotizaciones Privadas',
      value: stats.totalPrivateQuotations,
      color: '#ff9800'
    }
  ];

  return (
    <div className={styles.section}>

      <div className={styles.statsGrid}>
        {statCards.map((card, index) => (
          <div key={index} className={styles.statCard}>
            <div className={styles.iconWrapper} style={{ backgroundColor: `${card.color}15` }}>
              <card.Icon
                className={styles.icon}
                style={{ color: card.color }}
                size={28}
              />
            </div>
            <div className={styles.statContent}>
              <span className={styles.statLabel}>{card.label}</span>
              <span className={styles.statValue}>{card.value}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminDashboardSection;
